import { Component, OnInit } from '@angular/core';

@Component({
	templateUrl: './publication.component.html',
	styleUrls: ['./publication.component.scss']
})

export class PublicationComponent implements OnInit {

	constructor() { }

	ngOnInit() { }
}
